import { render, staticRenderFns } from "./Naesin.vue?vue&type=template&id=14671cae"
import script from "./Naesin.vue?vue&type=script&lang=js"
export * from "./Naesin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports